/**
 * 2016 year - base year
 */
import { get, includes } from 'lodash';
import { numberFieldRestrict12Fn, numberFieldRestrict14_2Fn } from '../CommonValidations';
import { CONST_RESIDENT } from '../../constants/CODE_RESIDENT';

const ndfl3BreadCrumbsMapping = {
  initialData: {
    title: 'Титульный лист',
    order: 1,
  },
  inRF: {
    title: 'Лист А',
    order: 2,
  },
  outRF: {
    title: 'Лист Б',
    order: 3,
  },
  propertyDeduction: {
    title: 'Лист Д1',
    order: 4,
  },
  socialDeduction: {
    title: 'Лист Е1',
    order: 5,
  },
  standardDeduction: {
    title: 'Лист Е1',
    order: 6,
  },
  investmentDeduction: {
    title: 'Лист Е2',
    order: 7,
  },
  lossesTransferDeduction: {
    title: 'Лист З',
    order: 8,
  },
};

export class NDFL3DefaultLogic {
  name() {
    return 'default';
  }

  showLossesTransferDeduction() {
    return true;
  }

  showSumOfPreviousPeriods() {
    return true;
  }

  showKikNumber() {
    return true;
  }

  showDetermProcedureKIK() {
    return true;
  }

  showNumWorkedMonths() {
    return false;
  }

  getPFIorFISS() {
    return 'ПФИ';
  }

  /*
   * Удалены поля
   * "остаток вычета, перешедший с предыдущего периода",
   * "остаток вычета по процентам, перешедший с предыдущего периода",
   * "дата заявления о распределении имущественного налогового вычета",
   * "год начала использования вычета",
   * "вид собственности"
   */
  showRemainsFields() {
    return true;
  }

  isComplexDwellingRegDateName() {
    return false;
  }

  disablePersonalDataFields() {
    return false;
  }

  showObjectIf() {
    return true;
  }

  /**
   * Видимость полей Адрес в Российской Федерации
   *
   * @returns {boolean}
   */
  isVisiblePrAddressForYear(year) {
    return year < 2017;
  }

  /**
   * Видимость полей Сумма расходов на прохождение независимой оценки своей квалификации
   *  и пункта в списке 'Социальные налоговые вычеты' на шаге 'Выбор вычетов'
   *
   * @returns {boolean}
   */
  isVisibleAssessmentQualifications() {
    return false;
  }

  /**
   * Видимость компонента с адресом на шаге Имущественный вычет
   *
   * @returns {boolean}
   */
  isVisibleAddressDeductionForYear() {
    return true;
  }

  /**
   * Видимость полей Остаток вычета, перешедший с предыдущего периода и процентам на шаге Имущественный вычет
   *

   * @returns {boolean}
   */
  isVisibleRemainderDeductionPreviousPeriodForYear() {
    return true;
  }

  /**
   * Видимость полей:
   *  Вид номера объекта
   *  Номер объекта
   *  У объекта нет официально присвоенного адреса
   *  Сведения о местонахождении объекта
   *  на шаге Имущественный вычет
   *
   * @returns {boolean}
   */
  isVisibleNumberAndViewObjectForYear() {
    return false;
  }

  /**
   * Изменять ли состояние в зависимости от года на шаге Имущественный вычет
   */
  isDispatchPropertyDeductionFieldsForYear() {
    return false;
  }

  showObjectAddress() {
    return false;
  }

  getLabelForCharityLiveDeductionSelected() {
    return 'Вычет по расходам на обучение, лечение, благотворительность, оценку квалификации';
  }

  isVisibleAdditionalFieldsForYear() {
    return false;
  }

  /**
   * Disable поля incomeSum + расчет на шаге 'Доходы'
   * @returns {boolean|*}
   */
  isIncomeSumForYear() {
    return false;
  }

  getIncomeFieldsFormat() {
    return numberFieldRestrict14_2Fn;
  }

  getTaxSumFieldsFormat() {
    return numberFieldRestrict12Fn;
  }

  getNDFL3BreadCrumbsMapping() {
    return ndfl3BreadCrumbsMapping;
  }

  getInvestmentBreadcrumbBinding() {
    return 'investmentDeduction';
  }

  hideNotReleasedFunctionality() {
    return false;
  }

  showTaxDeduction() {
    return true;
  }

  showTaxRate() {
    return true;
  }

  showTaxForeignIncomeSum() {
    return false;
  }

  hide2018Fields() {
    return false;
  }

  showApplyDeduction() {
    return false;
  }

  disableDeductionSum() {
    return false;
  }

  displayAddMoreDeductions(incomeCode) {
    const incomeCodesForMultipleDeductions = [
      1544,
      1545,
      1546,
      1547,
      1548,
      1549,
      1551,
      9551,
      1552,
      9552,
      1530,
      1536,
      1531,
      1532,
      1533,
      1535,
      1537,
      9537,
      1538,
      9538,
    ];
    return incomeCodesForMultipleDeductions.includes(incomeCode);
  }

  showLosses2018() {
    return false;
  }

  hideDeductionCodeByIncome() {
    return false;
  }

  disableByDeductionCode(incomeCode, deductionCode) {
    const disabled = {
      1530: [208, 216, 222],
    };

    return includes(get(disabled, incomeCode, []), deductionCode);
  }

  incomeCodesCanBeMoreThanIncomeSum(incomeCode) {
    const permittedListIncome = [
      1530,
      1531,
      1532,
      1533,
      1535,
      1536,
      1537,
      9537,
      1538,
      9538,
      1544,
      1545,
      1546,
      1547,
      1548,
      1549,
      1551,
      9551,
      1552,
      9552,
    ];

    return includes(permittedListIncome, incomeCode);
  }

  getSalaryIncomeTypeCodes13() {
    return [2000, 2001, 2002, 2003, 2010, 2012, 2300, 2530];
  }

  getSalaryIncomeTypeCodes30() {
    return [2000, 2001, 2002, 2003, 2010, 2012, 2300, 2530, 1010];
  }

  showDrugsExpenses() {
    return false;
  }

  showPurchaseMethod() {
    return false;
  }

  showAgentDeductionManual(reportYear) {
    return reportYear > 2017;
  }

  isVisibleSoldObjectPurchasedAfter(incomeCode) {
    return [1510, 1511].includes(incomeCode);
  }

  // использовать поля «Страна источника выплаты» и «Страна зачисления выплаты»
  // на вкладке доходов «За пределами РФ»
  useCountryIstAndZachForIncomesOutsideRF() {
    return false;
  }

  // Показывать поле «Сумма вычета, предоставленная в упрощенном порядке» на шаге "Вычеты", на вкладке «Инвестиционный налоговый вычет»
  showSumOfSimplifiedTaxDeduction() {
    return false;
  }

  // Показывать поле «Налоговая ставка (%)» на вкладках «В пределах РФ» и «За пределами РФ»
  // при выборе дохода 4800
  showTaxRateOnlyForOtherIncomes() {
    return false;
  }

  // true = в попапе «Новый объект имущества» в поле «Вид номера объекта» убрать значения
  // «Условный номер» и «Инвентарный номер»
  showOnlyCadastralNumberOptionInAddPropertyObjectForm() {
    return false;
  }

  // Показывать поле «Сумма налога на прибыль организаций, подлежащая зачету» для дохода
  isShowSumOfCorporateIncomeTax() {
    return false;
  }

  // Показывать поле «Уплаченная сумма фиксированных авансовых платежей, подлежащая зачету» для дохода
  showSumOfFixedAdvancePaymentsForIncome() {
    return false;
  }

  // На вкладке «Инвестиционный вычет» добавить блок полей о ИИС (индивид. инвест. счет)
  showIISData() {
    return false;
  }

  // Показывать поле «Сумма налога исчисленная» на вкладке «Доходы»
  showTaxAmountCalculatedWithDividends() {
    return true;
  }

  // Показывать для нерезидентов радиокнопку "Доход получен в качестве высококвалифицированного специалиста" на вкладке «Доходы»
  showIsHighClassSpecialistField() {
    return false;
  }

  // Показывать поле  «Сумма материальной выгоды, подлежащая возврату» для доходов вид дохода = 19
  showSumOfMaterialBenefitToRefundField() {
    return false;
  }

  // Применить новую логику формирования доходов
  isNewIncomeTypesFilter() {
    return false;
  }

  // Показывать новые Итоги декларации на основе данных ndfl3.ndfl3Package.payload.amounts
  showNewNdfl3Preview() {
    return false;
  }
  // Применить новую логику формирования доходов
  getTaxRateOptions(isResident = true) {
    // Статус налогоплательщика (1 - резидент РФ, 2 - не резидент РФ)
    if (isResident === CONST_RESIDENT) {
      return [
        { label: '13', value: 13 },
        { label: '35', value: 35 },
        { label: '9', value: 9 },
      ];
    }
    return [
      { label: '30', value: 30 },
      { label: '15', value: 15 },
      { label: '13', value: 13 },
    ];
  }

  // Показывать для Дивидентов доп поля (Сумма дивидендов, Исчисленный налог, Удержанный налог)
  showSpecialFieldsForDividendsIncome() {
    return true;
  }

  showLocationInfoIf(objectTypeViewValue) {
    return objectTypeViewValue === '4';
  }

  showNumberObject() {
    return true;
  }
}
